import { Link } from 'react-router-dom';
import { PageHeader } from './PageHeader';

export function NotFoundPage() {
  return (
    <main className="page">
      <PageHeader
        section="Not found"
        title="No such page"
        lede="That page does not exist. Head back to Home."
      />
      <div className="page__actions">
        <Link className="button button--primary" to="/">
          Go to Home
        </Link>
      </div>
    </main>
  );
}
